export default class UserTradingOrderSeller {
  constructor($scope) {
    $scope.tabs = ['Bank Details'];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
    };

    $scope.init();
  }
}

UserTradingOrderSeller.$inject = ['$scope'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-trading-order-seller.ctrl.js